// src/tour/components/TourBubble.js
//
// The bubble itself. Renders title, body, an optional CTA; the easy-out footer
// is handled by the overlay. The bubble owns: an optional arrow pointing at the
// anchor, a progress dot row (counts only countsTowardProgress steps), and the
// "you'll end with a printed Emergency Sheet" reassurance line on early steps.

import { TC, touchBtn } from './tourTheme'

function Dots({ total, current }) {
  if (!total) return null
  return (
    <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginTop: 16 }} aria-hidden="true">
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          style={{
            width: i === current ? 9 : 7,
            height: i === current ? 9 : 7,
            borderRadius: '50%',
            background: i === current ? TC.dotActive : TC.dotInactive,
            transition: 'all 120ms ease',
          }}
        />
      ))}
    </div>
  )
}

function Arrow({ placement }) {
  // Triangle pointing toward the anchor. placement = where the bubble sits
  // relative to the anchor ('below' → arrow on top edge, 'above' → bottom edge).
  const base = {
    position: 'absolute',
    left: 24,
    width: 0,
    height: 0,
    borderLeft: '9px solid transparent',
    borderRight: '9px solid transparent',
  }
  if (placement === 'below') {
    return <span style={{ ...base, top: -9, borderBottom: `9px solid ${TC.bubbleBg}` }} />
  }
  if (placement === 'above') {
    return <span style={{ ...base, bottom: -9, borderTop: `9px solid ${TC.bubbleBg}` }} />
  }
  return null
}

export default function TourBubble({
  title,
  body,
  footerLine,
  cta,
  onCta,
  arrowPlacement,
  dotsTotal,
  dotsCurrent,
  children,           // extra controls (e.g. pointer Next / Back) from the overlay
}) {
  return (
    <div
      role="dialog"
      aria-modal="false"
      style={{
        position: 'relative',
        background: TC.bubbleBg,
        border: `1px solid ${TC.bubbleBorder}`,
        borderRadius: 14,
        boxShadow: '0 10px 36px rgba(44,29,20,0.24)',
        padding: '18px 18px 16px',
        boxSizing: 'border-box',
      }}
    >
      <Arrow placement={arrowPlacement} />
      {title && (
        <div style={{ fontFamily: TC.fHead, fontSize: 18, color: TC.body, lineHeight: 1.3 }}>
          {title}
        </div>
      )}
      {body && (
        <div style={{ fontFamily: TC.fBody, fontSize: 14.5, color: TC.body, marginTop: 8, lineHeight: 1.5 }}>
          {body}
        </div>
      )}
      {cta && (
        <button
          onClick={onCta}
          style={{
            ...touchBtn,
            marginTop: 16,
            width: '100%',
            border: 'none',
            background: TC.primary,
            color: '#fff',
            fontWeight: 600,
          }}
        >
          {cta.label}
        </button>
      )}
      {children}
      {footerLine && (
        <div style={{ fontFamily: TC.fBody, fontSize: 12.5, color: TC.muted, marginTop: 14, textAlign: 'center', fontStyle: 'italic' }}>
          {footerLine}
        </div>
      )}
      <Dots total={dotsTotal} current={dotsCurrent} />
    </div>
  )
}
